import React from 'react'
import { Link } from "react-router-dom";
import './mission.css'
import Wave from '../wave/Wave'
import penelope_gif from '../../assets/Logo Waving.gif'
import boy_6 from '../../assets/boy_6.JPG'

const HIGHLIGHTS = [
  { icon: '🏅', title: 'Nationally Accredited', text: 'Accredited by the National Accreditation Commission for Early Care and Education Programs.', color: 'var(--yellow)' },
  { icon: '🧩', title: 'Montessori + Traditional', text: 'The best of both teaching styles and equipment.', color: 'var(--purple-500)' },
  { icon: '🕡', title: 'Long, Flexible Hours', text: 'Open 6:30am to 6:30pm to fit busy family schedules.', color: 'var(--teal)' },
  { icon: '📖', title: 'Free 4-Hour VPK', text: 'Starts with a free literacy hour, before Florida’s required 3-hour VPK day.', color: 'var(--pink)' },
]

export default function Mission() {
  return (
    <section className='mission'>
      <div className='mission-inner'>
        <div className='mission-visual'>
          <img className='mission-photo' src={boy_6} alt="Little boy doing a puzzle" />
          <img src={penelope_gif} alt="Penelope waving" className="mission-hippo" />
        </div>
        <div className='mission-copy'>
          <span className="section-eyebrow">Our Mission</span>
          <h2 className="section-title">A school where learning never stands still</h2>
          <p>We are a specialty school that offers classes for children from 1 year old through pre-kindergarten ages. Our curriculum is a unique blend of Montessori and Traditional teaching methods which helps develop successful, well rounded children. Our students receive the best of both educational techniques and equipment; offered at a fair and reasonable tuition. We are excited to offer such a unique program to this community. We call it <i>Learning in Motion</i>.</p>
          <Link to='/about' className="btn btn-purple">Learn More About Us</Link>
        </div>
      </div>

      <ul className='mission-cards'>
        {HIGHLIGHTS.map((h) => (
          <li key={h.title} className='mission-card' style={{ '--accent': h.color }}>
            <span className='mission-card-icon' aria-hidden="true">{h.icon}</span>
            <h3>{h.title}</h3>
            <p>{h.text}</p>
          </li>
        ))}
      </ul>

      <Wave color="var(--lavender)" />
    </section>
  )
}
